/**
 * Reviews class - třída s funkcemi pro obsluhu recenzí
 */
var Reviews = window.Reviews = function () {
    this.selectBrand = $('.selectBrand');
    this.selectModel = $('.selectModel');
}

Reviews.prototype.init = function () {
    var self = this;
    this.selectBrand.on('change', function () {
        self.changeContent(true);
    });
    this.selectModel.on('change', function () {
        self.changeContent(false);
    });
}

Reviews.prototype.reload = function () {
    var self = this;
    $('.selectModel').on('change', function () {
        self.changeContent(false);
    });
}

Reviews.prototype.loadModelSelect = function () {
    var self = this;
    $.nette.ajax({
        url: '/recenze',
        success: function (payload) {
            self.data = payload;
        }
    }).error(function () {
        console.log('error getMenuJson())');
    }).done(function () {
        $('.akontace.selected').click();
        $('.splatky.selected').click();
    });
}


Reviews.prototype.changeContent = function (isSelectBrand) {
    var self = this;
    window.app.prependOverlayContent();
    $.nette.ajax({
        url: '/recenze',
        data: {
            znacka: self.selectBrand.val(),
            model: isSelectBrand ? '-' : $('.selectModel').val()
        }
    }).done(function () {
        $('.selectModel').select2();
        self.reload();
    });
};